export default __webpack_public_path__ + "static/media/logo.b440eea2.svg";